import { useEffect } from 'react';
import { ErrorBoundary } from './components/ui/ErrorState';
import { AppRouter } from './router/index';
import { AuthModal } from './components/auth/AuthModal';
import { TwoFactorChallengeModal } from './components/auth/TwoFactorChallengeModal';
import { useNotifications } from './hooks/useIntelligentScheduling';
import { autoNotificationTrigger } from './services/autoNotificationTrigger';
import { cloudSyncService } from './services/cloudSyncService';
import { useAuthStore } from './store/authStore';
import { FeedbackForm } from './components/feedback/FeedbackForm';
import { useFeedbackStore } from './hooks/useFeedback';

function App() {
  // Initialize notification listeners to handle complete actions
  useNotifications();

  // Initialize auth state
  const { refreshAuthState } = useAuthStore();
  const { isOpen: isFeedbackOpen, closeFeedback } = useFeedbackStore();

  useEffect(() => {
    // Initialize auto notification trigger
    autoNotificationTrigger.initialize().catch(console.error);

    // Initialize authentication state
    refreshAuthState();

    // Start cloud sync if Google Drive is connected
    cloudSyncService.start();
    return () => cloudSyncService.stop();
  }, [refreshAuthState]);

  return (
    <ErrorBoundary>
      <AppRouter />
      <AuthModal />
      <TwoFactorChallengeModal />
      <FeedbackForm isOpen={isFeedbackOpen} onClose={closeFeedback} />
    </ErrorBoundary>
  );
}

export default App;